import { baseApi } from '@klp/core/api';

import { byggDokumentsApiRoutes } from './api';
import { ByggDokument } from './classes';
import type {
    ByggDokumentRequest,
    ByggDokumentResponse,
    IByggDokument,
} from './classes';

export const byggDokumentApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getByggDokumentList: builder.query<
            ByggDokumentResponse,
            ByggDokumentRequest
        >({
            query: (requestParams) => ({
                url: byggDokumentsApiRoutes.list(requestParams.byggNummer),
            }),
            transformResponse: (
                response: Array<IByggDokument>,
            ): ByggDokumentResponse => {
                const byggDokumentList = response.map(
                    (document: IByggDokument) =>
                        ByggDokument.parseObject(document),
                );
                return { byggDokumentList };
            },
            providesTags: (_result, _error, arg) => [
                { type: 'ByggDokument', id: arg.byggNummer },
            ],
        }),
    }),
});

export const { useGetByggDokumentListQuery, useLazyGetByggDokumentListQuery } =
    byggDokumentApi;
